import { CheckBoxType } from '../../types/checkboxTypes'
import { CheckBoxWrapper, Label } from './style'

const Checkbox = ({ label, checked, onClick, children }: CheckBoxType) => {
	return (
		<CheckBoxWrapper>
			<Label>
				<input
					type="checkbox"
					checked={checked}
					id="label"
					onChange={onClick}
				/>
				<label htmlFor="label">{label}</label>
				{children}
			</Label>
		</CheckBoxWrapper>
	)
}

export default Checkbox
